// extracted by mini-css-extract-plugin
module.exports = {"footer":"_6f065c","footerList":"_4aaf27","footerListItem":"_34c8e0"};